import { cloneDeep } from 'lodash-es'

export const mergeQueries = (filters, mergeFilters = {}) => {
  if (Object.keys(filters).length !== 0) {
    const _filters = cloneDeep(filters)
    const arr = []
    if (mergeFilters.queries) {
      mergeFilters.queries.forEach((que) => {
        const { slug, queryType, fixed } = que
        let flag = false
        _filters.queries.forEach((q) => {
          if (
            q.slug === slug &&
            (q.queryType.toString() === queryType.toString() ||
              (q.fixed && fixed))
          ) {
            q.queryType = que.queryType
            q.value = que.value
            q.remove = que.remove
            flag = true
          }
        })
        if (!flag) {
          arr.push(que)
        }
      })
    }
    arr.forEach((q) => {
      _filters.queries.push(q)
    })

    const finalQueries = _filters.queries.filter((v) => v.remove !== true)
    return { ..._filters, queries: finalQueries }
  }
  const finalQueries = mergeFilters.queries.filter((v) => v.remove !== true)
  return { ...mergeFilters, queries: finalQueries }
}
